var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState } from 'react';
import { CFBaseIconSVGElements, CFBaseIconTokens, CFBaseIcons, CFTokens, getCFBaseIcon, } from '@connectrn/ds-ui-base';
import { useCFTestID } from '../../hooks';
import { CFIconElements } from './Icon.styles';
export const CFIcon = (_a) => {
    var { color = CFBaseIconTokens.COLORS.FILL, icon, size = 'md', variant = 'outlined', title } = _a, rest = __rest(_a, ["color", "icon", "size", "variant", "title"]);
    const { commonAttrs, elementTestID } = useCFTestID('cf-icon', rest);
    const [iconSVG, setIconSVG] = useState(null);
    const [defaultTitle, setDefaultTitle] = useState('');
    const { Wrapper, IconSVG } = CFIconElements;
    useMemo(() => {
        const iconConfigs = getCFBaseIcon(CFBaseIcons, icon);
        setIconSVG(iconConfigs === null || iconConfigs === void 0 ? void 0 : iconConfigs.source(CFBaseIconSVGElements(), {
            color: CFTokens.isCFColor(color)
                ? CFTokens.getCFColorValue(color)
                : color,
            variant,
        }));
        setDefaultTitle(iconConfigs === null || iconConfigs === void 0 ? void 0 : iconConfigs.defaultTitle);
    }, [icon, variant]);
    return (React.createElement(Wrapper, Object.assign({ size: size, "aria-label": title || defaultTitle }, commonAttrs),
        React.createElement(IconSVG, Object.assign({}, elementTestID('svg'), { "$color": color, viewBox: '0 0 24 24' }), iconSVG)));
};
